import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NotificationService } from '../../service/notification.service';
import { Observable, Subscription } from 'rxjs';
import { NotificationType } from '../../enum/notification-type.enum';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormControl, NgForm } from '@angular/forms';
import { ReportModel } from '../report.model';
import { ScheduleModel } from '../schedule.model';
import { ReportService } from '../report.service';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { RefreshService } from '../refresh.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-report-view',
  templateUrl: './report-view.component.html',
  styleUrls: ['./report-view.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ReportViewComponent implements OnInit, AfterViewInit {
  private subscriptions: Subscription[] = [];
  public reportModelQuery = new ReportModel();
  public refreshing: boolean;
  public ctype: string;
  reposnseData: ReportModel[] = [];
  selectedIds: ReportModel[] = [];
  isChecked: boolean = false;
  expandedElement: null;
  expandedElementInstances: null;

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  //fileName: string = 'ReportsData';

  public repid: number;
  public reportSql: string;
  public reportName: string;
  public parms: string = "";

  public reportModel = new ReportModel();
  public scheduleModel = new ScheduleModel('', '', '', '', '', '');

  public displayedColumns = ['Select', 'reportName', 'reportDesc', 'reportType', 'category', 'status', 'instance', 'update'];
  public dataSource = new MatTableDataSource<ReportModel>();

  public displayedColumnsInstances = ['instanceName', 'sqlLabels', 'sqlParams', 'scheduler', 'distName', 'status', 'runReport', 'update', 'delete'];
  public dataSourceInstances = new MatTableDataSource<ReportModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  supervisorNamesSet = new Set<string>();
  public showLoading: boolean;

  filteredDistOptions: Observable<any[]>;
  myControlDist = new FormControl();
  public resDist: ReportModel[] = [];
  public resCat: ReportModel[] = [];
  public excelReportView: ReportModel[] = [];
  public excelResultReportView: ReportModel[] = [];

  public dynaParms: ReportModel[] = [];
  public parmsLength: number;

  filteredCategoryOptions: Observable<any[]>;
  myControl = new FormControl();

  columnsExcelData: any;
  dataForExcel = [];
  resultForExcel = [];
  dataForHeadersExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  isAccessDisabled: boolean = false;

  constructor(private globalService: GlobalService, private router: Router, private reportService: ReportService, private httpService: HttpClient,
    public ete: ExportExcelService, private notificationService: NotificationService, private refreshService: RefreshService) { }

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('create-report');

    this.refreshService.notifyObservable$.subscribe(res => {
      if (res.refresh) {
        console.log("Refresh View Report");
        this.reportService.getDistList();
      }
    })

    this.getReports();
    this.getCategoryData();
    this.getDistributionData();
    this.initializeExcelHeaders();
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.reportView;
      }
    );
  }



  public getCategoryData() {
    console.log("getCategoryData()");
    this.filteredCategoryOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val2 => {
        return this.getCategoryList(val2 || '')
      })
    )
  }
  public getCategoryList(val2: string): Observable<any[]> {
    //console.log("getCategoryList()==" + val2);
    return this.reportService.getCatList()
      .pipe(
        map(res => res.filter(opt => {
          this.resCat = res;
          // console.log("this.resCat="+JSON.stringify(this.resCat));
          return opt.category.toLowerCase().indexOf(val2.toLowerCase()) === 0
        }))
      )
  }
  public getSelectedCat(desc: string) {
    //console.log("getSelectedCat()");
    var cpdata = "";
    this.getCategoryData();
    if(desc){
      cpdata = this.resCat.find(cat => cat.category === desc).category;
    }
    return cpdata;
  }

  public onDeleteInstance(id: number): void {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      console.log("delete id === " + id);
      if (confirm("Are you sure to delete this instance")) {
        this.subscriptions.push(
          this.reportService.deleteInstance(id).subscribe(
            (response: CustomHttpRespone) => {
              this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
              this.getReports();
            },
            (error: HttpErrorResponse) => {
              this.notificationService.sendNotification(NotificationType.ERROR, error.error.message);
            }
          )
        );
      }
    }
  }

  public getReportInstances(repid: number) {
    this.reportService.getReportInstances(repid)
      .subscribe((res: any) => {
        this.dataSourceInstances = res;
      });
  }

  public getDistributionData() {
    console.log("getDistributionData Called");
    this.filteredDistOptions = this.myControlDist.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val1 => {
        return this.getDistList(val1 || '')
      })
    )
  }

  public getDistList(val1: string): Observable<any[]> {
    return this.reportService.getDistList()
      .pipe(
        map(response => response.filter(option => {
          this.resDist = response;
          return option.distName.toLowerCase().indexOf(val1.toLowerCase()) === 0
        }))
      )
  }
  public getSelectedDist(distri: number) {
    var cpdata = "";
    this.getDistributionData();
    //console.log("getSelectedDist === "+this.resDist);
    if(distri){
      cpdata = this.resDist.find(distribute => distribute.distId === distri).distName;
    }
    return cpdata;
  }

  public onEditReport(repModel: ReportModel): void {
    this.reportModel = repModel;
    this.clickButton('openReportEditModel');
  }

  public onEditInstance(repModel: ReportModel): void {
    this.reportModel = repModel;
    this.clickButton('openInstanceEditModel');
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public getReports(): void {
    this.subscriptions.push(
      this.reportService.getReports().subscribe(
        (response: ReportModel[]) => {
          this.dataSource.data = response;
          //console.log(JSON.stringify(response));
          this.excelReportView = JSON.parse(JSON.stringify(response));
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }

  public onUpdateReport(): void {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      const formData = this.reportService.createForm(this.reportModel);
      this.subscriptions.push(
        this.reportService.onUpdateReport(formData).subscribe(
          (response: ReportModel) => {
            this.clickButton('closeEditReportModalButton');
            this.getReports();
            this.notificationService.sendNotification(NotificationType.SUCCESS, `Updated successfully`);
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          }
        )
      );
    }

  }

  public onUpdateInstance(): void {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      const formData = this.reportService.createInstanceForm(this.reportModel);
      this.subscriptions.push(
        this.reportService.onUpdateInstance(formData).subscribe(
          (response: ReportModel) => {
            this.clickButton('closeEditInstanceModalButton');
            this.getReports();
            this.notificationService.sendNotification(NotificationType.SUCCESS, `Updated successfully`);
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          }
        )
      );
    }
  }

  public getReportId(repid: number, reportSql: string, reportName: string) {
    //console.log(kpiid);
    this.repid = repid;
    this.reportSql = reportSql;
    this.reportName = reportName;
    this.getReportInstances(this.repid);
  }


  public runReport(instanceName: string, sqlparms: string) {
    this.excelResultReportView = [];
    if (sqlparms == "") {
      sqlparms = "NA";
    }

    this.reportModelQuery.reportSql = this.reportSql;
    this.reportModelQuery.sqlParams = sqlparms;
    console.log(this.reportModelQuery);

    this.reportService.runReport(this.reportModelQuery)
      .subscribe((response: any) => {
        //console.log("Response = " + JSON.stringify(response));
        if (response.length > 0) {
          this.reposnseData = response;
          this.excelResultReportView = JSON.parse(JSON.stringify(response));
          this.exportResultExcel();
        } else {
          this.notificationService.sendNotification(NotificationType.ERROR, 'No Records Found!!');
        }

      });
  }

  exportResultExcel() {
    //console.log(this.excelResultReportView);
    this.dataForExcel = [];
    this.dataForHeadersExcel = [];
    let reportData = null;
    this.excelResultReportView.forEach((row: any) => {
      //console.log("obj === " + Object.values(row));
      this.resultForExcel.push(Object.values(row));
      this.dataForHeadersExcel.push(Object.keys(row));
    })
    console.log(this.resultForExcel);
     reportData = {
      title: 'ReportView',
      data: this.resultForExcel,
      headers: this.dataForHeadersExcel[0]
    }
    this.ete.exportExcel(reportData);
  }

  exportExcel() {
    for (let js of this.excelReportView) {
      delete js.id;
      delete js.reportSql;
      delete js.distList;
      delete js.distName;
      delete js.distId;
      delete js.sqlParams;
      delete js.instanceName;
      delete js.scheduleStr;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelReportView.forEach((row: any) => {
      console.log("obj === " + Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'ReportView',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  public onSchedule(repModel: ReportModel): void {
    this.reportModel = repModel;
    this.scheduleModel.id = repModel.id;
    console.log("onSchedule ====" + this.scheduleModel.id);
    this.clickButton('openSchedule');
  }

  public onUpdateSchedule(): void {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      const formData = this.reportService.createScheduleForm(this.scheduleModel);
      this.subscriptions.push(
        this.reportService.onUpdateSchedule(formData).subscribe(
          (response: ReportModel) => {
            this.clickButton('closeScheduleModalButton');
            this.getReports();
            this.notificationService.sendNotification(NotificationType.SUCCESS, `Added successfully`);
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          }
        )
      );
    }
  }

  public onInstance(repModel: ReportModel): void {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      this.reportModel.id = repModel.id;
      this.reportModel.reportSql = repModel.reportSql;
      console.log("id====" + this.reportModel.id);
      console.log("reportSql====" + this.reportModel.reportSql);

      if (this.reportModel.reportSql.indexOf("~") !== -1) {
        console.log("getParms if");
        this.parmsLength = this.reportModel.reportSql.split("~").length - 1;
        console.log("this.parmsLength = " + this.parmsLength);
        this.dynaParms = [];
        for (var i = 0; i < this.parmsLength; i++) {
          const reportParmModel = new ReportModel();
          this.dynaParms.push(reportParmModel);
        }
      } else {
        this.dynaParms = [];
        console.log("getParms else");
        this.parmsLength = 0;
        console.log("this.parmsLength = = " + this.parmsLength);
      }
      this.clickButton('openInstance');
    }
  }

  public onCreateInstance(): void {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      console.log("SQL PARMS === " + JSON.stringify(this.dynaParms));
      console.log("parmsLength === " + this.parmsLength);
      this.parms = "";
      for (var i = 0; i < this.parmsLength; i++) {
        this.parms = this.parms + this.dynaParms[i].sqlParams + ",";
      }
      this.parms = this.parms.slice(0, -1)
      console.log("this.parms===" + this.parms);

      this.reportModel.sqlParams = this.parms;

      const formData = this.reportService.createInstanceForm(this.reportModel);
      this.subscriptions.push(
        this.reportService.onCreateInstance(formData).subscribe(
          (response: ReportModel) => {
            this.clickButton('closeInstanceModalButton');
            this.getReports();
            this.notificationService.sendNotification(NotificationType.SUCCESS, `Created successfully`);
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          }
        )
      );
    }
  }


  public deleteReport(): void {
    //console.log("aa selctedKpis : " + this.selctedKpis);
    this.reportService.onDeleteReport(this.selectedIds)
      .subscribe(response => {
        //this.getInactiveKpis(false);
        this.getReports();
        response = response as ErrorResponseMessage;
        //console.log('updateKpiStatus response === ', response);
        this.selectedIds = [];
        this.isChecked = false;
      })
  }

  public selectedCalIds(rep: ReportModel, values: any) {
    //console.log('calc values == ' + JSON.stringify(values));
    this.reportModel = rep;
    if (values.currentTarget.checked) {
      this.selectedIds.push(this.reportModel);
    } else {
      this.selectedIds = [];
      this.selectedIds.forEach((value: any, index: any) => {
        if (value.id == rep.id) this.selectedIds.splice(index, 1);
      });
    }
    console.log('selectedIds == ' + JSON.stringify(this.selectedIds));
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


}


